import { CaseClosureReason } from '../../../application/domain/entities/CaseClosureReason';
import { CaseClosureReasonDto } from '../dto/res/CaseClosureReasonResponseDto';

export class CaseCloseMapper {
    static toDomain(dto: CaseClosureReasonDto): CaseClosureReason {
        return {
            code: dto.code,
            name: dto.name,
        };
    }
}
